/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const IsNotNullPrimitiveString: core.serialization.ObjectSchema<
    serializers.IsNotNullPrimitiveString.Raw,
    Truvity.IsNotNullPrimitiveString
> = core.serialization.object({});

export declare namespace IsNotNullPrimitiveString {
    export interface Raw {}
}
